import React from 'react';
import { Modal, Button } from 'antd';

interface ViewProps {
    message?: string
}

export const ModalResetPasswordSuccess : React.FunctionComponent<ViewProps> = (props) => {
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
    const message = React.useMemo( ()=>{
        return ( props.message ) ? props.message : '';
    }, [ props.message ] );

    const handleModalToggle = React.useCallback( ()=>{
        window.location.reload();
    }, [] );

    React.useEffect( ()=>{
        setIsModalOpen( message.trim() !== '' );
    }, [message] );


    return (

        <Modal
            title="Información:"
            open={isModalOpen}
            onCancel={handleModalToggle} //
            width={600}
            footer={[
                <Button key="confirm" type="primary" onClick={handleModalToggle}>
                    OK
                </Button>,
            ]}
        >
            {message}
        </Modal>
    );
};
